export default __webpack_public_path__ + "static/media/36I-102705_-17091_0.049c5a8b.jpg";